<template>
    <label class="px-1" for="forLabel">
        <span class="font-weight-medium textColor--text">{{ label }}</span>
        <span class="asterix px-1">*</span>
    </label>
</template>

<script>
export default {
    name: 'BaseLabel',
    props: {
        label: {
            type: String,
            required: true
        },
        forLabel: {
            type: String
        }
    }
}
</script>

<style scoped>
.asterix{
  color: #A72223;
  vertical-align: -2px;
}

</style>
</template>